<template>
  <div class="OUpload">
    <div class="img-uploader">
      <!-- image preview -->
      <div class="preview">
        <div class="img-item" v-for="image in images" :key="image">
          <!-- <previewImage :image="image" class="prev" /> -->
          <img :src="$store.state.apiUploadUrl + image" alt="Preview Image" />
          <span class="delete" @click="removeImage(image)">
            <i class="fas fa-trash"></i>
          </span>
          <span class="uploaded" v-if="image.uploadStatus == 'uploaded'"
            >Uploaded</span
          >
          <span class="failed" v-if="image.uploadStatus == 'failed'"
            >Failed</span
          >
        </div>
        <div class="dropzone" v-if="images.length < 1">
          <div>
            <div class="flex-col-center">
              <i class="fas fa-cloud-upload-alt"></i>
              <p>{{ text }}</p>
              <button class="outline">Add Image</button>
            </div>
          </div>
          <div v-if="multiple && images.length > 0">+</div>
          <input
            type="file"
            @change="upload"
            :multiple="multiple"
            accept="image/*"
            ref="file"
          />
        </div>
        <div class="dropzone2" v-else>
          <span v-if="multiple">+</span>
          <span class="change" v-else>Change</span>
          <input
            type="file"
            @change="upload"
            :multiple="multiple"
            accept="image/*,.pdf,.doc,.docx,.xml,application/msword,.xlsx,.xlsm,"
            ref="file"
          />
        </div>
      </div>
      <!-- single image uploader dropzone -->
    </div>
    <div class="progress" v-if="uploadStatus == 'in-progress'">
      <div class="progress-bar" :style="{ width: progress + '%' }"></div>
    </div>
  </div>
</template>
<script>
// import previewImage from "./previewImage.vue";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
export default {
  name: "OUpload",
  components: {
    // previewImage,
  },
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    uploadUrl: {
      type: String,
      default: "files/upload",
    },
    imagesBaseUrl: {
      type: String,
      default: "http://localhost:3000/",
    },
    value: {
      type: [String, Array],
      default: "",
    },
    text: {
      type: String,
      default: "Drag and drop image here, or click here to add image",
    },
  },
  data() {
    return {
      images: [],
      imagesToUpload: [],
      previewUrl: "",
      progress: 0,
      currentUploading: 0,
      uploadStatus: "start",
    };
  },
  methods: {
    upload() {
      if (this.$refs.file.files.length == 0) return;
      this.imagesToUpload.push(this.$refs.file.files[0]);
      this.uploadImages(this.$refs.file.files);
    },
    removeImage(image) {
      this.images = this.images.filter((img) => img != image);
      if (this.multiple) {
        this.$emit("imagesUploaded", this.images);
      } else {
        this.$emit("imagesUploaded", this.images[0]);
      }
    },
    async uploadImages($images) {
      this.progress = 0;
      // emit startLoader event
      let itemsCount = $images.length;
      let increment = 100 / itemsCount;
      this.uploadStatus = "in-progress";

      setInterval(() => {
        this.progress += 5;
      }, 100);

      for (let i = 0; i < itemsCount; i++) {
        await this.uploadNow($images[i]);
        if (i == itemsCount - 1) {
          this.progress = 100;
        }
      }
      this.uploadStatus = "end";
    },
    async uploadNow($image) {
      await this.$store
        .dispatch("UPLOADIMAGES", {
          file: $image,
          url: this.uploadUrl,
        })
        .then((res) => {
          console.log(res);
          if (res.data.file_name) {
            if (this.multiple) {
              this.images.push(res.data.file_name);
            } else {
              console.log(res.data.file_name);
              this.images = [res.data.file_name];
            }
            if (this.multiple) {
              this.$emit("imagesUploaded", this.images);
            } else {
              this.$emit("imagesUploaded", this.images[0]);
            }
          } else {
            this.imagesToUpload.forEach((img) => {
              if (img.name == $image.name) {
                img.uploadStatus = "failed";
                this.$emit("imagesUploadedFailed", $image);
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.imagesToUpload.forEach((img) => {
            if (img.name == $image.name) {
              img.uploadStatus = "failed";
              this.$emit("imagesUploadedFailed", $image);
            }
          });
          toast.error("Failed to upload image");
        });
    },
  },
  mounted() {
    if (this.value) {
      if (this.multiple) {
        this.images = this.value;
      } else {
        this.images = [this.value];
      }
    }
  },
  watch: {
    value(val) {
      if (this.multiple) {
        this.images = val;
      } else {
        this.images = [val];
      }
    },
    progress(val) {
      if (val >= 100) {
        this.progress = 100;
        this.uploadStatus = "end";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$primary_color: #1d2088;
$secondary_color: #1eb9ee;
.OUpload {
  .img-uploader {
    display: flex;
    flex-wrap: wrap;
  }
  .preview {
    display: flex;
    flex-wrap: wrap;
    row-gap: 10px;
    column-gap: 10px;

    width: 100%;
    .img-item {
      width: 100px;
      height: 100px;
      position: relative;
      .delete {
        position: absolute;
        top: -5px;
        right: -5px;
        background: #c40505;
        color: #fff;
        padding: 5px;
        border-radius: 50%;
        font-size: 10px;
        width: 25px;
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &:hover {
          background: #780202;
        }
      }
      .uploaded {
        position: absolute;
        bottom: 0;
        left: 0;
        background: #4f934c;
        color: #fff;
        padding: 3px 5px;
        border-radius: 0 0 5px 5px;
        font-size: 10px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .failed {
        position: absolute;
        bottom: 0;
        left: 0;
        background: #c40505;
        color: #fff;
        padding: 3px 5px;
        border-radius: 0 0 5px 5px;
        font-size: 10px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .prev {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .dropzone {
    width: 100%;
    height: 180px;
    border: 2px dashed #e2e2e2;
    background: #f5f5f5;
    position: relative;
    cursor: pointer;
    border-radius: 10px;
    &:hover {
      // border: 10px dashed #000;
    }
    input {
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
    span,
    .flex-col-center {
      font-size: 2rem;
      color: #ccc;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      cursor: pointer;
      &.change {
        font-size: 1rem;
      }
    }
  }
  .dropzone2 {
    width: 100px;
    height: 100px;
    border: 1px dashed $primary_color;
    position: relative;
    cursor: pointer;
    &:hover {
      border: 1px dashed #000;
      background: $secondary_color;
    }
    input {
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
    span {
      font-size: 2rem;
      color: $primary_color;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      cursor: pointer;
      &.change {
        font-size: 1rem;
      }
    }
  }
  .upload-btn {
    button {
      padding: 10px 20px;
      border: none;
      border-radius: 5px;
      background: #000;
      color: #fff;
      margin-top: 10px;
      cursor: pointer;
      &:hover {
        background: #333;
      }
    }
  }
}
.flex-col-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 10px;
  width: 100%;
  p {
    font-size: 1.05rem;
    color: #000;
    padding: 0 10px;
    text-align: center;
  }
  img {
    width: 40px;
    height: 40px;
  }
}
.outline {
  font-size: 1rem;
}
.progress {
  width: 100%;
  height: 5px;
  background: #cfcfcf;
  position: relative;
  height: 10px;
  border-radius: 50px;
  overflow: hidden;
  margin-top: 1rem;
  .progress-bar {
    height: 100%;
    background: rgb(52, 201, 52);
    transition: width 0.5s ease-in-out;
  }
}
</style>